module.exports = __webpack_public_path__ + "img/beaver_change.6d0bf512.png";